export default __webpack_public_path__ + "static/media/avatarB7.ff88b281.png";